import { BookOpen } from 'lucide-react'
import { useAuth } from '../../AuthContext'
import { KnowledgeBasePanel } from '../../components/KnowledgeBasePanel'
import { ChatbotContextPanel } from '../../components/ChatbotContextPanel'
import { PageHeader } from '../../components/PageHeader'
import { SociedadScope } from '../../components/SociedadPicker'

function KnowledgeBaseView({ sociedadId }: { sociedadId: string }) {
  const { user } = useAuth()
  const rank = user?.sociedades.find((s) => s.id === sociedadId)?.rank

  return (
    <div className="flex flex-col gap-6">
      {rank === 'owner' && <ChatbotContextPanel sociedadId={sociedadId} />}
      <KnowledgeBasePanel activeSociedadId={sociedadId} />
    </div>
  )
}

export function KnowledgeBasePage() {
  return (
    <div className="flex flex-col gap-6">
      <PageHeader icon={BookOpen} title="Base de conocimiento" description="Las FAQ que el bot responde sin usar IA." />
      <SociedadScope>{(sociedadId) => <KnowledgeBaseView sociedadId={sociedadId} />}</SociedadScope>
    </div>
  )
}
